module.exports = __webpack_public_path__ + "static/media/image22.07d96281.jpg";